import { Navigate } from "react-router-dom"
import { useAuth } from "@/contexts/AuthContext"
import { ReactNode } from "react"
import LoadingOverlay from "./LoadingOverlay"
// import { jwtDecode } from "jwt-decode"

interface ProtectedRouteProps {
  children: ReactNode
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return <LoadingOverlay />
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
      />
    )
  }

  return <>{children}</>
}
